import { combineReducers } from 'redux';

import { reducer as attachmentsReducer } from '@savgroup-front-common/core/domains/attachments';
import { reducer as fileUploadReducer } from '@savgroup-front-common/core/domains/fileUpload';
import {
  I18N_KEY,
  reducer as i18nReducer,
} from '@savgroup-front-common/core/domains/i18n';
import {
  SAGA_REQUEST_METADATA_KEY,
  reducer as sagaRequestMetadataReducer,
} from '@savgroup-front-common/core/domains/sagaRequestMetadata';
import { reducer as sellerConfigurationReducer } from '@savgroup-front-common/core/domains/sellerConfiguration';
import {
  SELLER_DOMAIN_KEY,
  sellerReducer,
} from '@savgroup-front-common/core/domains/sellers';

import {
  SELLERS_INFO_DOMAIN_KEY,
  reducer as sellersInfoReducer,
} from './sellersInfo';
import { USER_MANAGEMENT_KEY, userManagementReducer } from './userManagement';
import { USERS_DOMAIN_KEY, usersReducer } from './users';

const createRootReducer = () =>
  combineReducers({
    attachments: attachmentsReducer,
    [USERS_DOMAIN_KEY]: usersReducer,
    [I18N_KEY]: i18nReducer,
    [USER_MANAGEMENT_KEY]: userManagementReducer,
    fileUpload: fileUploadReducer,
    [SELLERS_INFO_DOMAIN_KEY]: sellersInfoReducer,
    sellerConfiguration: sellerConfigurationReducer,
    [SELLER_DOMAIN_KEY]: sellerReducer,
    [SAGA_REQUEST_METADATA_KEY]: sagaRequestMetadataReducer,
  });

export default createRootReducer;
